
















import Vue from 'vue';

export default Vue.extend({
  name: 'discord-icon',
  props: {
    color: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
});
